import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaskRegularAiIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.6 8q1.2.2 1.1 1.4-.2 1.1-1.4 1.2a8 8 0 0 0-7.6 9.3 7.9 7.9 0 0 0 15 2 8 8 0 0 0 .7-3.5q0-1.2 1.2-1.6 1.2 0 1.4 1.1a11 11 0 0 1-5.5 9.8A10.5 10.5 0 1 1 13.6 8m1.7 7.7a1 1 0 0 1 1.7 1L13.7 22a1 1 0 0 1-.8.4 1 1 0 0 1-.8-.4l-2-2.6a1 1 0 1 1 1.6-1.2l1 1.5zM22.9 3q.5 0 .6.5v.1l.3 1.3q.3 1.4 1 2 1 1 2 1l1.3.4h.1a.6.6 0 0 1 0 1.2l-1.4.3q-1.3.3-2 1-.9 1-1 2l-.3 1.3v.1a.6.6 0 0 1-1.2 0l-.3-1.4q-.4-1.3-1-2-1-.9-2-1l-1.4-.3a.6.6 0 0 1 0-1.2L19 8q1.4-.3 2-1 1-1 1-2l.4-1.4.6-.6" })
});
export default SvgTaskRegularAiIcon;
